import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, inject, input, model } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { FormsModule } from "@angular/forms";

import { WirelessTicket } from "../../components/models/wireless-ticket";
import { WirelessSuppliersItem } from "../../components/subscription-detail/shortcut-menu/items/wireless-suppliers/wireless-suppliers-item";
import { WirelessTicketsItem } from "../../components/subscription-detail/shortcut-menu/items/wireless-tickets/wireless-tickets-item";
import { MessageService } from "../../services/messageservice";
import { SubscriptionsTagsFilterComponent } from "./subscriptions-tags-filter";

@Component({
  selector: "wireless-subscriptions-filter",
  templateUrl: "wireless-subscriptions-filter.html",
  styleUrls: ["../../components/subscription-detail/shortcut-menu/shortcut-menu.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, WirelessSuppliersItem, SubscriptionsTagsFilterComponent, TranslatePipe, WirelessTicketsItem],
})
export class WirelessSubscriptionsFilterComponent {
  private msgsrv = inject(MessageService);

  collectedTags = input.required<string[]>();
  activeTags = model.required<string[]>();
  servicesSearch = model.required<string>();
  tickets = input.required<WirelessTicket[]>();
  suppliers = input.required<string[]>();

  constructor() {
    this.msgsrv.enableFilter$.pipe(takeUntilDestroyed()).subscribe(({ type, value }) => {
      if (type === "tag") this.activeTags.update((tags) => [...tags, value]);
    });

    this.msgsrv.disableFilter$.pipe(takeUntilDestroyed()).subscribe(({ type, value }) => {
      if (type === "tag") this.activeTags.update((tags) => tags.filter((t) => t !== value));
    });
  }
}
